import {useState, useEffect} from "react";
import BasicInfo from "./BasicInfo";
import {StepsContainerStyled} from "../../../../styled/Resume";
import EducationInfo from "./EducationInfo";
import ExperienceInfo from "./ExperienceInfo";
import SkillsInfo from "./SkillsInfo";
import CertificationInfo from "./CertificationInfo";
import PublicationInfo from "./PublicationInfo";
import LanguageInfo from "./LanguageInfo";
import { useTheme } from "../../../UI/Theme/ThemeContext";
import CreateStepNav from "./CreateStepNav";

const CreateStep = (props) => {
    const [step, setStep] = useState(1)
    const [stepData, setStepData] = useState({});
    console.log(stepData);
    const { themeName } = useTheme();

    useEffect(() => {
        const handleNav = (e) => {
            if (e.detail && e.detail.step) {
                setStep(e.detail.step);
            }
        };
        document.addEventListener('navToCreateStep', handleNav);
        return () => document.removeEventListener('navToCreateStep', handleNav);
    }, []);

    const {
    // setStepsDone,
        basicInfo,
        handleInputChange,
        jobConnectType,
        jobTypesArray,
        handleJobConnectType,
        additionalInfo,
        setAdditionalInfo,
        basicLinkInfo,
        basicHandleAddLinks,
        basicHandleDeleteLinks,
        basicHandleLinkChange,
        eduArray,
        handleEduExpChange,
        handleDeleteEduInfo,
        handleAddEduInfo,
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,
        interests,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,
        basicInfoForward,
        eduInfoForwardOrBackward,
        workExpForwardOrBackward,
        skillsForwardOrBackward,
        certsForwardOrBackward,
        pubForwardOrBackward,
        langForwardOrBackward,
        interestsBackward,
        onSubmitCreate,

    } = props;

    return (
            <StepsContainerStyled theme={themeName}>
                <CreateStepNav step={step} setStep={setStep} />
                {step === 1 &&
                    <BasicInfo
                        basicInfo={basicInfo}
                        handleInputChange={handleInputChange}
                        setStep={setStep}
                        jobConnectType={jobConnectType}
                        handleJobConnectType={handleJobConnectType}
                        jobTypesArray={jobTypesArray}
                        additionalInfo={additionalInfo}
                        setAdditionalInfo={setAdditionalInfo}
                        stepData={stepData}
                        setStepData={setStepData}
                        basicLinkInfo={basicLinkInfo}
                        basicHandleAddLinks={basicHandleAddLinks}
                        basicHandleDeleteLinks={basicHandleDeleteLinks}
                        basicHandleLinkChange={basicHandleLinkChange}
                        basicInfoForward={basicInfoForward}
                    />
                }
                {step === 2 &&
                    <EducationInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        eduArray={eduArray}
                        handleEduExpChange={handleEduExpChange}
                        handleDeleteEduInfo={handleDeleteEduInfo}
                        handleAddEduInfo={handleAddEduInfo}
                        eduInfoForwardOrBackward={eduInfoForwardOrBackward}
                    />
                }

                {step === 3 &&
                    <ExperienceInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        workExpArray={workExpArray}
                        handleWorkExpChange={handleWorkExpChange}
                        handleDeleteExp={handleDeleteExp}
                        handleAddExp={handleAddExp}
                        workExpForwardOrBackward={workExpForwardOrBackward}
                    />
                }
                {step === 4 &&
                    <SkillsInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        skills={skills}
                        handleSkillChange={handleSkillChange}
                        handleDeleteSkill={handleDeleteSkill}
                        handleAddSkill={handleAddSkill}
                        skillsForwardOrBackward={skillsForwardOrBackward}
                    />
                }

                {step === 5 &&
                    <CertificationInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        awardArray={awardArray}
                        handleAwardChange={handleAwardChange}
                        handleDeleteAward={handleDeleteAward}
                        handleAddAward={handleAddAward}
                        certsForwardOrBackward={certsForwardOrBackward}
                    />
                }

                {step === 6 &&
                    <PublicationInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        publications={publications}
                        handlePubChange={handlePubChange}
                        handleDeletePublication={handleDeletePublication}
                        handleAddPublication={handleAddPublication}
                        pubForwardOrBackward={pubForwardOrBackward}
                    />
                }

                {step === 7 &&
                    <LanguageInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        languages={languages}
                        handleLangChange={handleLangChange}
                        languageStore={languageStore}
                        langLevelsArray={langLevelsArray}
                        handleDeleteLang={handleDeleteLang}
                        handleAddLang={handleAddLang}
                        langForwardOrBackward={langForwardOrBackward}

                    />
                }

                {step === 8 &&
                    <SkillsInfo
                        step={step}
                        setStep={setStep}
                        stepData={stepData}
                        setStepData={setStepData}
                        interests={interests}
                        handleInterestChange={handleInterestChange}
                        handleDeleteInterests={handleDeleteInterests}
                        handleAddInterests={handleAddInterests}
                        interestsBackward={interestsBackward}
                        onSubmitCreate={onSubmitCreate}
                    />
                }
            </StepsContainerStyled>
    );
}

export default CreateStep;